"use strict";

const esasIssueMapping = {
  anxietyCategory: {
    issues: [
      {
        id: "I-ESAS-20300",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  appetiteCategory: {
    issues: [
      {
        id: "I-ESAS-20900",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  depressionCategory: {
    issues: [
      {
        id: "I-ESAS-21000",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  drowsinessCategory: {
    issues: [
      {
        id: "I-ESAS-21200",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  nauseaCategory: {
    issues: [
      {
        id: "I-ESAS-20500",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  painCategory: {
    issues: [
      {
        id: "I-ESAS-20200",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  tirednessCategory: {
    issues: [
      {
        id: "I-ESAS-21100",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  wellbeingCategory: {
    issues: [
      {
        id: "I-ESAS-21300",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  dyspneaCategory: {
    issues: [
      {
        id: "I-ESAS-20400",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  constipationCategory: {
    issues: [
      {
        id: "I-ESAS-20700",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  diarrheaCategory: {
    issues: [
      {
        id: "I-ESAS-20600",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  },
  vomitingCategory: {
    issues: [
      {
        id: "I-ESAS-20800",
        domain: "DPS"
      }
    ],
    triggerValues: ["mild", "moderate", "severe", "unbearable"]
  }
};

module.exports = {
  esasIssueMapping
};
